import React, { useState } from "react";
import { Event } from "../types/Event";
import "../styles/EventPage.css";

interface AlbumCardProps {
  event: Event;
  onClick: () => void;
  onAddPhoto: (eventId: number, file: File | null) => void; 
  roleRank?: number;
}

const truncateText = (text: string, maxLength: number) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const AlbumCard: React.FC<AlbumCardProps> = ({ event, onClick, onAddPhoto, roleRank, }) => {
  const [showPopup, setShowPopup] = useState(false);

  const hasImages = event.images && event.images.length > 0;
  const cover = hasImages
    ? event.images![0].path
    : "https://via.placeholder.com/400x300?text=Aucune+Image";

  const formattedStartDate = new Date(event.start_date).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const formattedEndDate = event.end_date
    ? new Date(event.end_date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : null;

  return (
    <>
      <div className="album-card" onClick={onClick}>
        {hasImages ? (
          <>
            <img src={cover} alt={event.titre} className="album-img" />
            <div className="album-hover">
              <h4>{event.titre}</h4>
              <p>{truncateText(event.description || "", 50)}</p>
            </div>
          </>
        ) : (
          <div className="no-image-label">
            <h4>{event.titre}</h4>
            <p>{truncateText(event.description || "", 50)}</p>
            <p>
              <strong>Date début:</strong> {formattedStartDate}<br />
              {formattedEndDate && (
                <>
                  <strong>Date fin:</strong> {formattedEndDate}<br />
                </>
              )}
              <strong>Lieu:</strong> {event.lieu || "Non spécifié"}
            </p>
          </div>
        )}

        {(roleRank ?? 0) >= 5 && (
          <div
            className="album-add"
            onClick={(e) => {
              e.stopPropagation();
              setShowPopup(true);
            }}
          >
            +
          </div>
        )}
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h4>Ajouter une photo</h4>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                onAddPhoto(event.id_event, e.target.files?.[0] || null);
                setShowPopup(false);
              }}
            />
            <button className="btn btn-secondary mt-3" onClick={() => setShowPopup(false)}>
              Annuler
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AlbumCard;
